import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import "./job-posted-card.style.scss";

const JobPostedCard = ({ job }) => {
  return (
    <div className="job-posted-card-main">
      <div className="jpcm-header">
        <div>
          <img src={Images.menTree} />
        </div>
        <h5 className="job-title modal-job-title">{job?.job_title}</h5>
      </div>
      <div className="jpcm-info">
        <span>
          <img src={Images.blueBook} />
          {job?.job_curiculum}
        </span>
        <span>
          <img src={Images.groupLogo} />
          {job?.job_class}
        </span>
        <span>
          <img src={Images.suitcaseLogo} />
          {job?.job_type}
        </span>
        <span>
          <img src={Images.manWIthStars} />
          {job?.job_experience} exp
        </span>
        <span>
          <img src={Images.moneyLogo} />
          {/* {job?.job_salary_range} */}
          {job && job.job_salary_range
            ? `${job.job_salary_range.start} - ${job.job_salary_range.end}`
            : "-"}
        </span>
      </div>
      <button className="modal-apply-button">
        <Link to={`/institute/job/createjobpost?id=${job?._id}`}>
          Import Details
        </Link>
      </button>
    </div>
  );
};
export default JobPostedCard;
